'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Radio", {
    enumerable: true,
    get: function() {
        return Radio;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderRadio = require("./renderRadio");
const _useRadio = require("./useRadio");
const _useRadioStylesstyles = require("./useRadioStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Radio = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useRadio.useRadio_unstable)(props, ref);
    (0, _useRadioStylesstyles.useRadioStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useRadioStyles_unstable')(state);
    return (0, _renderRadio.renderRadio_unstable)(state);
});
Radio.displayName = 'Radio';
